import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { BonusdetailPage } from '../bonusdetail/bonusdetail';

/**
 * Generated class for the BonuslistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-bonuslist',
  templateUrl: 'bonuslist.html',
})
export class BonuslistPage {

    segment: string = 'btn01';

	loginId: string;
	email: string;
    api_key: string;
    version: string;

	list_one: any = [];
	list_two: any = [];
	list_three: any = [];
	list_four: any = [];
	name: any = [];
    // params: any[] = [];
    // count: number = 0;
    // max_length: number = 0;
    
	coin_unit: string;
	unit: string;
	cash_room_unit: string;
	bonus_room_unit: string;
    
    balance: any = [];
    // balance_usdt: string;
	texts: any = [];
    language : string;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
        // private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {
		this.segment = navParams.get("target");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "withdrawalcoinlist");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.unit = localStorage.getItem("unit");
		this.cash_room_unit = localStorage.getItem("cash_room_unit");
		this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).bonus;
	}

	_init() {		
		this.list_one = [];
		this.list_two = [];
		this.list_three = [];
		this.list_four = [];
		
        let url = "bonus/base";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.balance = res.balance;
                this.name = res.name;

                if (res.list != undefined) {   
                    if(res.list.one != undefined) {
                        this.list_one = res.list.one;
                    }
                    if(res.list.two != undefined) {
                        this.list_two = res.list.two;
                    }
                    if(res.list.three != undefined) {
                        this.list_three = res.list.three;
                    }
                    if(res.list.four != undefined) {
                        this.list_four = res.list.four;
                    }
                }
				
				// if(res.list != undefined) {
				// 	this.list = res.list;
				// 	this.max_length = res.list.length;
				// 	this.params = [];
				// 	this.count = 0;
				// 	for (var i = 0; i < 9; i++) {
				// 		if(this.max_length <= this.count) break;
				// 		this.params.push(this.items[this.count]);
				// 		this.count++;
				// 	}
				// }
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

    _list_two(date) {
        let modal = this.modalCtrl.create(BonusdetailPage, {tab: 'two', date: date});
        modal.present();
        modal.onDidDismiss( tab => {
            if (tab != '') {
                this.segment = 'btn02';
            }
        });
    }

    _list_three(date) {
        let modal = this.modalCtrl.create(BonusdetailPage, {tab: 'three', date: date});
        modal.present();
        modal.onDidDismiss( tab => {
            if (tab != '') {
                this.segment = 'btn03';
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/bonuslist/bonuslist.ts